import { FC, ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router';

import { useAppSelector } from '@/store';
import { loggedInSelector } from '@/store/auth/selectors';

function getSafeRedirect(redirectTo: string | null): string {
  if (redirectTo && redirectTo.startsWith('/') && !redirectTo.startsWith('//') && !redirectTo.includes('://')) {
    return redirectTo;
  }
  return '/';
}

const GuestRoute: FC<{ children?: ReactElement }> = ({ children }) => {
  const loggedIn = useAppSelector(loggedInSelector);

  if (loggedIn) {
    return <Navigate to={getSafeRedirect(new URLSearchParams(location.search).get('redirect_to'))} replace />;
  }

  return children ? children : <Outlet />;
};

export default GuestRoute;
